
import Select, { components } from 'react-select';
import { useGetAllPrevUsersQuery } from '../../slices/usersApiSlice';
import { useMemo } from 'react';

const SelectPrevUsers = ({ selectedPrevUser, setSelectedPrevUser, prevUsers }) => {

  const options = useMemo(() => {
    if (prevUsers.length === 0) return [];
    return prevUsers.map(user => ({ 
      ...user, label: user.last_name + ' ' + user.first_name, value: user.id_user
    }))
  }, [prevUsers]);

  const handleChange = (option) => {
    setSelectedPrevUser(option)
  }
  
  return (
    <Select
      maxOptions={70} 
      options={options} 
      className="select-brief-container w-[230px]" classNamePrefix={'select-brief'}
      isSearchable={true} isClearable={true}
      placeholder={'Choisissez un gymnaste'} 
      onChange={(option) => handleChange(option)}
    />
  )
}

export default SelectPrevUsers